export const supportsReceipts: Boo.Objects.Enums.PartnerEnum[] = [
  Boo.Objects.Enums.PartnerEnum.Boostability
];